export interface ArticleContent {
  id: string;
  videoId: string;
  title: string;
  author: string;
  date: string;
  category: string;
  categoryName: string;
  views: number;
  rating: number;
  duration: string;
  thumbnail: string;
  content: string;
  tags: string[];
  relatedVideos: string[];
}

export const articles: ArticleContent[] = [
  {
    id: 'a001',
    videoId: 'v001',
    title: '2026年度热门影视精选合辑 | 91视频倾情推荐',
    author: '向日葵编辑团队',
    date: '2026-07-28',
    category: '91-video',
    categoryName: '91视频',
    views: 1285600,
    rating: 9.2,
    duration: '45:30',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20digital%20video%20platform%20interface%20with%20warm%20golden%20accents%2C%20cinematic%20film%20reel%20and%20play%20button%20on%20dark%20background%2C%20professional%20video%20streaming%20aesthetic%2C%20clean%20minimal%20design%20with%20soft%20lighting&width=640&height=360&seq=v001-thumb&orientation=landscape',
    content: `<h2>2026年度影视精选：不可错过的精彩</h2>
<p>2026年已经过半，影视市场迎来了诸多令人惊喜的作品。从震撼视觉的科幻巨制到温情脉脉的现实题材，从紧张刺激的悬疑片到引人深思的文艺作品，今年的影视作品呈现出百花齐放的态势。向日葵视频的编辑团队经过精心筛选，为您整理出这份年度热门影视精选合辑。</p>

<h3>科幻与奇幻：视觉的极致盛宴</h3>
<p>2026年的科幻电影在视觉效果上达到了新的高度。多部作品采用最前沿的虚拟制作技术，将观众带入前所未有的奇幻世界。无论是太空探索的宏大叙事，还是赛博朋克的未来想象，都以惊人的细节和真实感征服了观众。其中，一部讲述人类与AI共存的影片引发了广泛的社会讨论，成为今年最受关注的科幻作品之一。</p>

<h3>现实主义题材：触动人心的故事</h3>
<p>今年的现实主义题材影视作品同样值得关注。多部聚焦社会热点、关注普通人生的影片凭借真挚的情感和扎实的叙事赢得了观众和评论界的一致好评。这些作品不依赖华丽的特效，而是以细腻的人物刻画和深刻的社会洞察力打动了无数观众。</p>

<h3>悬疑与惊悚：烧脑之旅</h3>
<p>悬疑片爱好者今年也不会失望。多部制作精良的悬疑惊悚片以其巧妙的情节设计和出人意料的结局，让观众在影院中体验了一场场精彩绝伦的烧脑之旅。这些影片往往在二刷时能发现更多的细节和伏笔，值得反复品味。</p>

<p>向日葵视频将持续为您更新最新的影视资讯和精选内容，敬请关注我们的91视频频道。</p>`,
    tags: ['热门推荐', '高清影视', '2026新片', '精选合辑'],
    relatedVideos: ['v006', 'v011', 'v016'],
  },
  {
    id: 'a002',
    videoId: 'v003',
    title: '探索未知世界 | 51视频自然纪录片特辑',
    author: '向日葵编辑团队',
    date: '2026-07-22',
    category: '51-video',
    categoryName: '51视频',
    views: 672100,
    rating: 9.0,
    duration: '58:20',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20golden%20sunlight%20through%20forest%20canopy%2C%20wildlife%20silhouette%2C%20cinematic%20photography%20style%2C%20warm%20earthy%20tones&width=640&height=360&seq=v003-thumb&orientation=landscape',
    content: `<h2>走进自然的奇迹：51视频自然纪录片特辑</h2>
<p>在这个快节奏的数字时代，我们常常忘记了脚下这片土地的壮美与神奇。51视频自然纪录片特辑，邀您一同走进地球上那些令人惊叹的自然奇观，感受大自然的鬼斧神工。</p>

<h3>深海探秘：蓝色星球的未知领域</h3>
<p>海洋覆盖了地球表面约71%的面积，但人类对深海的了解甚至不及对月球表面的认识。本次纪录片特辑中，我们将跟随深海探测器潜入数千米深的海底世界，近距离观察那些奇异的深海生物。发光的深海水母、巨大的深海鱿鱼、古老的海底热泉生态系统，每一个画面都令人叹为观止。</p>

<h3>极地之旅：冰雪世界的生命赞歌</h3>
<p>从北极的冰川到南极的冰原，极地地区是地球上最严酷却也最壮美的自然景观之一。我们的摄制团队历时数月，克服零下数十度的严寒，记录下北极熊母子在冰原上的温馨互动、企鹅族群抵御暴风雪的顽强身影，以及极光在夜空中舞动的震撼画面。</p>

<h3>热带雨林：地球的绿色心脏</h3>
<p>热带雨林被誉为"地球之肺"，这里孕育了地球上最为丰富的生物多样性。在本次特辑中，您将看到色彩斑斓的箭毒蛙、优雅穿行于林间的美洲豹、以及数以千计的奇异昆虫和鸟类。每一个镜头都是对生命多样性的礼赞。</p>

<p>51视频自然纪录片特辑，用镜头记录自然之美，用故事传递环保理念。让我们一同守护这颗蓝色星球。</p>`,
    tags: ['纪录片', '自然探索', '高清摄影', '科普教育'],
    relatedVideos: ['v007', 'v013', 'v015'],
  },
  {
    id: 'a003',
    videoId: 'v005',
    title: '2026数码产品深度评测 | 数字视频大全科技频道',
    author: '向日葵编辑团队',
    date: '2026-07-18',
    category: 'digital-video',
    categoryName: '数字视频大全',
    views: 423800,
    rating: 8.6,
    duration: '35:15',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20tech%20gadgets%20on%20minimal%20desk%20setup%20with%20warm%20ambient%20lighting%2C%20sleek%20device%20product%20photography%2C%20clean%20professional%20aesthetic%20with%20golden%20highlights&width=640&height=360&seq=v005-thumb&orientation=landscape',
    content: `<h2>2026数码产品深度评测：科技改变生活</h2>
<p>2026年，数码科技领域迎来了诸多令人兴奋的新品发布。从折叠屏手机的成熟应用到AI PC的全面普及，从智能穿戴设备的健康升级到智能家居的生态完善，今年的科技产品正在以前所未有的方式改变着我们的日常生活。数字视频大全科技频道为您带来最专业的产品深度评测。</p>

<h3>折叠屏手机：从尝鲜到实用</h3>
<p>经过几年的发展，折叠屏手机在2026年已经真正走向成熟。新一代折叠屏产品在铰链可靠性、屏幕耐用性和应用适配方面都有了质的飞跃。更重要的是，价格逐渐亲民化，使得折叠屏不再是少数人的玩具。我们的评测发现，今年的旗舰折叠屏在日常使用中的体验已经与传统直板机无异，同时在多任务处理和内容消费方面提供了显著的优势。</p>

<h3>AI PC：个人计算的下一站</h3>
<p>2026年被业界称为"AI PC元年"。搭载专用NPU（神经网络处理单元）的个人电脑开始大规模进入消费市场。这些AI PC能够在本地运行大语言模型、实时进行图像生成和视频处理，大幅提升了创作效率。我们的实测显示，在日常办公、内容创作和轻度AI应用场景下，AI PC相比传统PC的性能提升可达3-5倍。</p>

<h3>智能穿戴：健康管理新时代</h3>
<p>智能手表和健康手环在2026年实现了质的突破。全新的生物传感器技术使得无创血糖监测成为现实，血压监测的精度也达到了医疗级别。这些技术进步使得智能穿戴设备从"玩具"真正变成了"健康管理工具"，为用户的日常健康监护提供了可靠的数据支持。</p>

<p>数字视频大全科技频道将持续关注最新科技动态，为您带来更多专业、深度的产品评测内容。</p>`,
    tags: ['科技评测', '数码产品', '2026新品', '深度解析'],
    relatedVideos: ['v009', 'v012', 'v001'],
  },
];